import { render, staticRenderFns } from "./cotizacionButton.vue?vue&type=template&id=dde67526&scoped=true&lang=html&"
import script from "./cotizacionButton.vue?vue&type=script&lang=js&"
export * from "./cotizacionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde67526",
  null
  
)

export default component.exports